import type { Action } from 'vuex'
import type { HandleFlag, State } from './state'
import type { BulkRevisionSendEditTableItem, BulkRevisionSendEditTableList } from '@/views/product/BulkRevisionSendEdit/types'

import actionTypes from './actionTypes'

const actions: { [actionTypes: string]: Action<State, any> } = {
  // 一括改版送信（編集）画面 メッセージ
  [actionTypes.SET_MESSAGE]: ({ commit }, message: string): void => {
    commit(actionTypes.SET_MESSAGE, message)
  },

  // 一括改版送信（編集）画面 メッセージのエラー内容
  [actionTypes.SET_MESSAGE_ERROR]: ({ commit }, errorMessage: string): void => {
    commit(actionTypes.SET_MESSAGE_ERROR, errorMessage)
  },

  // 一括改版送信（編集）画面 テーブルリスト
  [actionTypes.SET_TABLE_LIST]: (
    { commit },
    tableList: BulkRevisionSendEditTableList
  ): void => {
    commit(actionTypes.SET_TABLE_LIST, tableList)
  },

  //送信先変更か追加のフラグ
  [actionTypes.SET_HANDLE_FLAG]: (
    { commit },
    flag: HandleFlag
  ): void => {
    commit(actionTypes.SET_HANDLE_FLAG, flag)
  },

  //一括改版送信の編集画面で選択したデータ
  [actionTypes.SET_SELECTED_ITEM]: (
    { commit },
    selectedItem: BulkRevisionSendEditTableItem
  ): void => {
    commit(actionTypes.SET_SELECTED_ITEM, selectedItem)
  },
}

export default actions
